import { render, staticRenderFns } from "./DestinationResult.vue?vue&type=template&id=06d0063e"
import script from "./DestinationResult.vue?vue&type=script&lang=js"
export * from "./DestinationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports